export default __webpack_public_path__ + "static/media/strong 8 mobilityflows.05e03fbc.jpg";